module.exports = __webpack_public_path__ + "static/ALLEGATO35-82c38e27f97e6d2f683e7db0257f9c4f.pdf";